import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import {
  getFormData,
  getFormUploads,
  getProcessInstances,
  submitConsent,
  updateFormField,
  getVoucherAuditor,
  startVoucherAudit
} from 'store/forms/actions';
import { TabsTimeline, FormFooter, TabsTimelineSub, Modal } from 'components';
import { isNil , isNull } from 'lodash';
import { checkUser, checkUserLogged, getUser} from 'store/user/actions';
import { getMainformDetails } from 'store/forms/actions';
import { stepsEquipmentSupplier } from './stepsEquipmentSupplier';
import { stepsServiceSupplier } from './stepsServiceSupplier';
import { useNavigate } from 'react-router-dom';
import { isVoucherAuditor } from '../../../utils';
import { ValidationBanner } from 'components/layout/components';
import { ReactComponent as WarningBlue } from 'assets/icons/warning-blue.svg';
import isEmpty from 'lodash/isEmpty';
import { Spin } from 'antd';

const MainFormsVoucherAuditor = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [current, setCurrent] = useState(0);
  const currentSubTab = useSelector(state => state.forms.carrier.currentSubTab);
  const user = useSelector(state => state.user);
  const privileges = useSelector(state => state.user.privileges);
  const task = useSelector(state => state.forms.task);
  const viewMode = useSelector(state => state.forms.carrier.viewMode);
  const carrier = useSelector(state => state.forms.carrier);
  const legalVat = useSelector(state => state.forms.carrier.legalVat);
  const activeFormId = useSelector(state => state?.activeForm?.activeFormId);
  const formId = useSelector(state => state?.forms?.formId);
  const forms = useSelector(state => state.forms);
  const applicationLoading = useSelector(state=>state.forms.applicationLoading);
  const activeTaskName = useSelector(state => state.forms.activeTaskName);
  const voucher = useSelector(state => state.forms?.supplier?.voucherInfo?.voucher);

  useEffect(() => {
    dispatch(getUser());
  }, [dispatch, params.processInstanceId]);

  useEffect(() => {
    if(params?.processInstanceId){
      dispatch(getMainformDetails(params?.processInstanceId));
    }
  }, [params?.processInstanceId]);

  useEffect(() => {
    dispatch(
      checkUserLogged(
        navigate,
        callback => {
          if(callback){
            dispatch(getUser());
          }
        }
      ),
    );
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
        dispatch(checkUser(navigate));
    }, process.env.REACT_APP_SESSION_CHECK_TIME);
    return () => clearInterval(intervalId);
  }, []);

useEffect(() => {
  const parameters = {
    voucherCode: params?.voucherNumber,
    supplierVatId: params?.supplierVat,
  };

  if (
    isVoucherAuditor(user?.groups) &&
    params?.supplierVat &&
    params?.voucherNumber
  ) {
    dispatch(startVoucherAudit(params.voucherNumber))
      .then(() => {
        dispatch(getVoucherAuditor(parameters));
      });
  }
}, [user?.groups, params?.voucherNumber, params?.supplierVat]);

  //RENDER FORMS function based on user and task
  const steps = useMemo(() => {
    if (!voucher || !user?.groups) {
      return []; // safe fallback while waiting
    }

    if(user?.groups && voucher){
    if(isVoucherAuditor(user?.groups) && voucher?.type === "EQUIPMENT"){
        return stepsEquipmentSupplier;
    }else if(isVoucherAuditor(user?.groups) && voucher?.type === "SERVICE"){
        return stepsServiceSupplier;
    }
    
    else{
      return null;
    }
  }
  },[voucher?.type, user]);

  //Set current step based on user and Status
  useEffect(() => {
    if (!steps) return;

    if (isVoucherAuditor(user?.groups)) {
        setCurrent(0);
    }else {
      setCurrent(0);
    }
  }, [activeTaskName, user, steps]);

  return (
    applicationLoading ?
    <div
      style={{
        position:"absolute",
        left:"50%",
        top:"50%"
      }}
    >
      <Spin size="large" />
    </div> 
    :
    <div id="mainforms-page-1" className="investor-form-container">
     {!isNil(current) && 
     <div className="investor-steps-footer-container">
      <TabsTimeline 
          tabs={steps}
          current={current} 
          setCurrent={setCurrent} 
          customClass={`custom-tabs-timeline active-tab-${current+1}`}
      />
      <FormFooter 
          tabs={steps}
          current={current} 
          setCurrent={setCurrent} 
          currentSubTab={currentSubTab} />
      </div>
      }
    </div>
  );
};

export default MainFormsVoucherAuditor;
